const ProfileImageComp = ({
  imageUrl = "",
  customClass = "h-12 w-12",
  is_opc = false,
  ...rest
}) => {
  return (
    <div
      style={{
        background: is_opc
          ? "linear-gradient(120deg, #E9D99E 36.85%, #E9D99E 66.27%)"
          : "transparent",
        padding: is_opc ? "2px" : "0px",
      }}
      className={`rounded-full  ${is_opc ? "border-transparent" : "border-2 border-[#BDBDBD]"} ${customClass}`}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt="profile"
          className={`w-full h-full object-cover rounded-full`}
          {...rest}
        />
      ) : null}
    </div>
  );
};

export default ProfileImageComp;
